import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { CtaButton } from '../CtaButton';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-275" data-mp="3hfcxe7wiwooc">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-blood text-blood" aria-hidden="true" data-id="element-276" data-mp="3r78ylrtwouws" data-mpi={index} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-277" data-mp="42jdxr0n2qke">
      <div className="mx-auto w-full max-w-5xl" data-id="element-278" data-mp="44nouswygpu6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-279" data-mp="92xl76uf1whd">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-280" data-mp="902wv48a7rio">
            ⭐ Reviews
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-281" data-mp="2atsm2d3hcluy">
            What physicians are saying about Hypertension Route
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-graphite/75 sm:text-base" data-id="element-282" data-mp="1sk9dcmcuqoe7">
            2,000+ physicians have already changed the way they approach
            hypertension management. They didn’t buy another PDF — they bought a
            faster, more organized way to make clinical decisions.
          </p>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-283" data-mp="1euz5nij6aohg">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-2xl bg-white p-5 shadow-card ring-1 ring-ink/[0.07] sm:p-6" data-id="element-284" data-mp="2bh13nfqta3rr">
              <Stars data-id="element-285" data-mp="22gvwn6pj57e4" />
              <blockquote className="mt-3 flex-1 text-[14px] leading-relaxed text-graphite/85 sm:text-[15px]" data-id="element-286" data-mp="22kjn1wzohdom">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-ink/[0.07] pt-4" data-id="element-287" data-mp="r4v4rixdd2u5">
                <img src={testimonial.image} alt={testimonial.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-blood/20" width={96} height={96} data-id="element-288" data-mp="m35pfr346309" />
                <div className="min-w-0" data-id="element-289" data-mp="ejwis5lzsiew">
                  <p className="text-[14px] font-bold leading-snug text-ink" data-id="element-290" data-mp="enaif639udin">
                    {testimonial.name}
                  </p>
                  <p className="text-[12px] leading-snug text-graphite/60" data-id="element-291" data-mp="4uv0g8rz5oxr">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-292" data-mp="3r3nw2oi6eslu">
          <CtaButton label="I want the same clarity in my consultations" data-id="element-293" data-mp="3w1fodjmqggqk" />
        </div>
      </div>
    </section>;
}